import { QuestionData } from './types';

export function TextAnswer({ question }: { question: QuestionData }) {
  return (
    <div
      style={{
        display: 'flex',
        border: '1px solid #69CC8D',
        borderRadius: '5px',
        backgroundColor: '#FFFFFF',
        padding: '6px',
        minHeight: '24px',
        justifyContent: 'space-between',
        flex: 1,
      }}
    >
      <div style={{ color: 'GrayText', marginRight: '6px' }}>
        {question.name}
      </div>
      <div>{question.answers?.[0]?.content}</div>
    </div>
  );
}

export function LongTextAnswer({ question }: { question: QuestionData }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #69CC8D',
        borderRadius: '5px',
        backgroundColor: '#FFFFFF',
        padding: '6px',
        minHeight: '24px',
        justifyContent: 'space-between',
        flex: 1,
      }}
    >
      <div style={{ color: 'GrayText', marginRight: '6px' }}>
        {question.name}
      </div>
      <div>{question.answers?.[0]?.content}</div>
    </div>
  );
}

export function RadioBooleanAnswer({ question }: { question: QuestionData }) {
  return (
    <div
      style={{
        display: 'flex',
        border: '1px solid #69CC8D',
        borderRadius: '5px',
        backgroundColor: '#FFFFFF',
        padding: '6px',
        minHeight: '24px',
        justifyContent: 'space-between',
        flex: 1,
      }}
    >
      <div style={{ color: 'GrayText', marginRight: '6px' }}>
        {question.name}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: '10px',
        }}
      >
        <div
          style={{
            width: '18px',
            height: '18px',
            border: '1px solid #000',
            marginRight: '5px',
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          {question.answers?.[0].option === 'Sim' ? 'X' : ''}
        </div>
        <span style={{ marginRight: '20px' }}>S</span>

        <div
          style={{
            width: '18px',
            height: '18px',
            border: '1px solid #000',
            marginRight: '5px',
            display: 'inline-block',
            textAlign: 'center',
          }}
        >
          {question.answers?.[0].option === 'Não' ? 'X' : ''}
        </div>
        <span>N</span>
      </div>
    </div>
  );
}

export function CheckboxAnswer({
  question,
  options,
}: {
  question: QuestionData;
  options: string[];
}) {
  return (
    <div
      style={{
        display: 'flex',
        border: '1px solid #69CC8D',
        borderRadius: '5px',
        backgroundColor: '#FFFFFF',
        padding: '6px',
        minHeight: '24px',
        justifyContent: 'space-between',
        flex: 1,
      }}
    >
      <div style={{ color: 'GrayText', marginRight: '6px' }}>
        {question.name}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginLeft: '10px',
        }}
      >
        {options.map((option) => (
          <>
            <div
              style={{
                width: '18px',
                height: '18px',
                border: '1px solid #000',
                marginRight: '5px',
                display: 'inline-block',
                textAlign: 'center',
              }}
            >
              {question.answers?.map(answer => answer.option).includes(option) ? 'X' : ''}
            </div>

            <span style={{ marginRight: '10px', fontSize: '10px' }}>{option}</span>
          </>
        ))}
      </div>
    </div>
  );
}
